// Package Imports
import React from 'react';
import { Form, Radio } from 'antd';

// Project Imports
import ConfigStyle from 'core/constants/ConfigStyle';
import { RadioInputProps } from 'components/radio/type';

const RadioInput = ({
  label,
  name,
  options,
  style,
  onChange,
  message,
  rules,
  required,
  defaultValue,
  initialValue,
  disabled,
}: RadioInputProps) => (
  <Form.Item
    label={
      label ? (
        <span
          style={{
            fontWeight: ConfigStyle.labelfontWeight,
            color: ConfigStyle.labelColor,
          }}
        >
          {label}
        </span>
      ) : null
    }
    name={typeof name === 'string' ? [name] : [...name]}
    rules={[
      { ...rules },

      {
        required,
        message,
      },
    ]}
    hasFeedback
    style={style}
    initialValue={initialValue}
  >
    <Radio.Group
      onChange={onChange}
      options={options}
      defaultValue={defaultValue}
      disabled={disabled}
    />
  </Form.Item>
);

export default RadioInput;
